import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ElementRef,
  Input,
  ViewEncapsulation,
  HostListener,
} from '@angular/core';
import { Router } from '@angular/router';
import { LockerCardAnimation } from './locker-card.animation';

@Component({
  selector: 'app-locker-card',
  templateUrl: './locker-card.component.html',
  styleUrls: ['./locker-card.component.scss'],
  animations: [LockerCardAnimation],
  // encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LockerCardComponent implements OnInit {
  @Input() locked: boolean = false;
  @Input() text?: string = 'Функционал доступен в другом тарифе';

  visible: boolean = false;

  constructor(
    private _router: Router,
    private _elementRef: ElementRef,
  ) {}

  ngOnInit(): void {}

  redirectTo() {
    this._router.navigateByUrl(`private-office/tariffs-and-payment`);
  }

  @HostListener('mouseenter', ['$event']) onMouseEnter(event: any) {
    this.visible = true;
  }

  @HostListener('mouseleave', ['$event']) onMouseLeave(event: any) {
    this.visible = false;
  }
}
